import { jsx as s, jsxs as r } from "react/jsx-runtime";
import { createStyles as _, Box as K, MediaQuery as u } from "@mantine/core";
import Q from "embla-carousel-autoplay";
import q from "embla-carousel-react";
import { useState as f, useCallback as c, useEffect as N } from "react";
import { NavigationButton as d, PlayControlButton as F, DotButton as G } from "./BannerCarouselButtons.js";
import { BannerCtaButtons as H } from "./BannerCtaButtons.js";
import { BREAKPOINT_MOBILE as J, BannerCarouselSlide as U } from "./BannerSlideItem.js";
const ne = ({ bannerSlideItems: p, delay: B = 6e3, loop: I = !0, mobileNavigationButtonSize: m = 24, mobileNavigationIconSize: h = 24, mobileSlideHeight: T = 280, navigationButtonSize: C = 40, navigationIconSize: y = 16, onCtaButtonsClick: P, onSlideClick: w, playControlButtonSize: D = 24, playControlIconSize: j = 14, slideHeight: E = 360 }) => {
  const L = _(() => ({
    bannerCarousel: {
      [`@media screen and (max-width: ${J})`]: {
        "--slide-height": `${T}px`
      },
      "--slide-height": `${E}px`,
      "--slide-size": "100%",
      "--slide-spacing": "1rem",
      position: "relative"
    },
    bannerCarouselContainer: {
      display: "flex",
      flexDirection: "row",
      height: "auto",
      marginLeft: "calc(var(--slide-spacing) * -1)"
    },
    bannerCarouselDots: {
      alignItems: "center",
      bottom: "12px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      left: 0,
      position: "absolute",
      right: 0,
      zIndex: 1
    },
    bannerCarouselSlide: {
      display: "flex",
      flex: "0 0 var(--slide-size)",
      height: "var(--slide-height)",
      justifyContent: "center",
      paddingLeft: "var(--slide-spacing)"
    },
    bannerCarouselViewport: {
      overflow: "hidden"
    }
  })), { classes: t } = L(), [x, e] = q({ loop: I }, [Q({ delay: B })]), [b, S] = f(0), [$, M] = f([]), [o, a] = f(!0), g = c(() => {
    a(!1), e == null || e.scrollPrev();
  }, [e]), v = c(() => {
    a(!1), e == null || e.scrollNext();
  }, [e]), O = c((l) => e == null ? void 0 : e.scrollTo(l), [e]), i = c(() => {
    e && S(e.selectedScrollSnap());
  }, [e, S]), R = () => {
    a(!o);
  };
  N(() => {
    var l, n, z, k;
    o ? (n = (l = e == null ? void 0 : e.plugins()) == null ? void 0 : l.autoplay) == null || n.play() : (k = (z = e == null ? void 0 : e.plugins()) == null ? void 0 : z.autoplay) == null || k.stop();
  }, [e, o]), N(() => {
    if (!e)
      return;
    M(e.scrollSnapList()), i();
    let l = !1;
    e.on("init", () => {
      l = !0;
    }), e.on("select", i), e.on("reInit", i), l || setTimeout(() => {
      e.reInit();
    }, 500);
  }, [e, x, i]);
  const V = p.map((l, n) => s(K, { "data-testid": "banner-carousel-slide", className: t.bannerCarouselSlide, sx: () => ({
    background: l.background ?? "#fff"
  }), children: s(U, { index: n, bannerSlideItem: l, onSlideClick: w }) }, n));
  return r("div", { className: t.bannerCarousel, children: [r("div", { className: t.bannerCarouselViewport, ref: x, children: [s("div", { className: t.bannerCarouselContainer, children: V }), s(u, { smallerThan: "sm", styles: { display: "none" }, children: r("div", { children: [s(d, { buttonSize: C, iconSize: y, isNext: !1, onClick: g }), s(d, { buttonSize: C, iconSize: y, onClick: v })] }) })] }), r("div", { className: t.bannerCarouselDots, children: [s(H, { slideIndex: b, bannerSlideItems: p, onCtaButtonsClick: P }), r("div", { style: { display: "flex" }, children: [s(F, { isPlay: o, onControlClick: R, buttonSize: D, iconSize: j }), s(u, { largerThan: "sm", styles: { display: "none" }, children: s("div", { children: s(d, { buttonSize: m, iconSize: h, isNext: !1, onClick: g, color: "gray.0", variant: "transparent" }) }) }), $.map((l, n) => s(G, { selected: n === b, onClick: () => {
    O(n), a(!1);
  } }, n)), s(u, { largerThan: "sm", styles: { display: "none" }, children: s("div", { children: s(d, { buttonSize: m, iconSize: h, onClick: v, color: "gray.0", variant: "transparent" }) }) })] })] })] });
};
export {
  ne as BannerCarousel
};
